import { useCallback } from 'react';

import { loadWhiteboardStore } from '../../components/whiteboard/loadAppWhiteboardStore';
import { DataChannelWhiteboardUpdateMessage } from '../../video-sdk';

export function useHandleWhiteboardUpdateCallback() {
  return useCallback(async (receivedMessage: DataChannelWhiteboardUpdateMessage) => {
    const store = await loadWhiteboardStore();
    store.mergeRemoteChanges(() => {
      store.applyDiff(receivedMessage.update.changes);
    });
  }, []);
}
